module.exports = __webpack_public_path__ + "img/tbLOGO.465d4a06.png";